import React from 'react';
import {
    Button,
    Grid,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import ChannelPreviewList from '../../../ui/ChannelPreviewList';
import { baseUrls } from '../../../../utils/baseUrls.utils';
import { useHistory } from 'react-router-dom';
import { Channel } from '../../../../shared/types';
import ChannelCardSkeleton from '../../../ui/ChannelCardSkeleton';

interface ChannelsSectionProps {
    title: string;
    channels: Channel[];
    loading: boolean;
    type?: 'premium' | 'free';
}

export const ChannelsSection = (props: ChannelsSectionProps) => {
    const { title, channels, loading, type } = props;
    const history = useHistory();
    const theme = useTheme();
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));

    const onBrowseButtonClick = () => {
        if (type) {
            history.push(`${baseUrls.channels.main}?type=${type}`);
            return;
        }

        return history.push(baseUrls.channels.main);
    };

    return (
        <>
            {loading || (!loading && channels?.length > 0) ? (
                <Grid
                    container
                    spacing={2}
                    sx={{
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 2,
                    }}
                >
                    <Grid
                        size={{
                            xs: 12,
                            sm: 'grow',
                        }}
                    >
                        <Typography variant="h5" component="h2">
                            {title}
                        </Typography>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 'auto',
                        }}
                    >
                        <Button
                            variant="contained"
                            fullWidth={xsDown}
                            onClick={onBrowseButtonClick}
                        >
                            Browse {type || ' '} channels
                        </Button>
                    </Grid>
                </Grid>
            ) : (
                <></>
            )}
            {!loading ? (
                <ChannelPreviewList channels={channels} loading={loading} />
            ) : (
                <Grid container spacing={2}>
                    {[0, 1, 2].map((key) => (
                        <Grid
                            key={key}
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 4,
                            }}
                        >
                            <ChannelCardSkeleton />
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    );
};
